export const evidencePreviewFields = [
  { key: "title", label: "Title", required: true },
  { key: "activityDescription", label: "Activity description", required: false },
  { key: "date", label: "Date of reflection", required: true },
  { key: "activity", label: "CPD Activity", required: true },
  { key: "activityDate", label: "Date of activity", required: true },
  { key: "numberOfHours", label: "Activity duration", required: false },
  { key: "customTags", label: "Custom tags", required: false },
  { key: "reflections", label: "Reflection", required: true },
  { key: "benefits", label: "Benefits", required: false },
  { key: "objectives", label: "Learning / Exercise objectives", required: false },
];
